import { Button } from '@treezor/design-system';

import { useTranslation } from 'react-i18next';

import { useCreateUserContext } from '@/features/user/contexts/CreateUserContext';

interface IFooter {
  nextTitle?: string;
  prevTitle?: string;
  onPrev?: () => void;
  onNext?: () => void;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  isLoading?: boolean;
  stepsLength: number;
}

export const CreateUserFooter = ({
  nextTitle,
  prevTitle,
  onPrev,
  onNext,
  isPrevDisabled,
  isNextDisabled,
  isLoading,
  stepsLength,
}: IFooter) => {
  const { t } = useTranslation();
  const { nextStep, prevStep } = useCreateUserContext();

  return (
    <div className="flex gap-4 items-center justify-end">
      <Button
        variant="tertiary"
        icon="arrow_back"
        onClick={() => {
          prevStep();
          onPrev?.();
        }}
        disabled={isPrevDisabled}
      >
        {prevTitle || t('pages.cores.previous')}
      </Button>
      <Button
        type="submit"
        isLoading={isLoading}
        icon="arrow_forward"
        iconPosition="right"
        onClick={() => {
          nextStep(stepsLength - 1 || Number.POSITIVE_INFINITY);
          onNext?.();
        }}
        disabled={isNextDisabled}
      >
        {nextTitle || t('pages.cores.next')}
      </Button>
    </div>
  );
};
